import { useEffect, useState } from 'react';
import {
  Button,
  Drawer,
  Grid,
  ListItem,
  ListItemText,
  makeStyles,
  MenuItem,
  TextField,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import StyledCheckbox from '../../../../../utils/componentutils/StyledCheckbox';
import Typography from '@material-ui/core/Typography';
import { testAlert } from '../../../../../stores/websocketStore/utils/outgoingMessages/testalert/testAlert';
import { sendUserPreferences } from '../../../../../stores/websocketStore/utils/outgoingMessages/userpreferences/sendUserPreferences';
import { ApplyChangesModal } from '../applyChangesModal/ApplyChangesModal';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';

const useStyles = makeStyles((theme) => ({
  root: {
    spacing: theme.spacing(10),
    border: '1px solid',
  },
  paper: {
    width: '45%',
    padding: '10px',
  },
  input: {
    fontSize: 10,
    width: '100%',
  },
}));

export default function UserAlertsPreferences({
  userPreferences,
  receivedUserPreferences,
}) {
  const [openApplyChangesModal, setOpenApplyChangesModal] = useState(false);
  const classes = useStyles();
  const [openUserAlertsPreferences, setOpenUserAlertPreferences] =
    useState(false);
  const {
    userPreferences: userPrefs,
    userAlerts: { userAlerts, setUserAlerts },
  } = userPreferences;

  const [emailAddressTxt, setEmailAddressTxt] = useState('');
  const [phoneNumberTxt, setPhoneNumberTxt] = useState('');
  const [carrierTxt, setCarrierTxt] = useState('');
  useEffect(() => {
    setEmailAddressTxt(userAlerts.emailAddress);
    if (
      userAlerts.phoneNumber !== undefined &&
      userAlerts.phoneNumber.length > 0
    ) {
      for (let index in userAlerts.phoneNumber) {
        let char = userAlerts.phoneNumber[index];
        if (char === '@') {
          let phoneNumber = userAlerts.phoneNumber.substring(
            0,
            parseInt(index)
          );
          setPhoneNumberTxt(phoneNumber);
          if (parseInt(index) + 1 < userAlerts.phoneNumber.length) {
            let carrier = userAlerts.phoneNumber.substring(parseInt(index) + 1);
            setCarrierTxt(carrier);
          }
          break;
        }
      }
    }
  }, [userAlerts]);

  const testService = () => {
    if (receivedUserPreferences) {
      sendUserPreferences(userPrefs);
      testAlert();
    }
  };
  return (
    <div>
      <ApplyChangesModal
        open={openApplyChangesModal}
        handleClose={() => {
          setOpenApplyChangesModal(false);
          setOpenUserAlertPreferences(false);
        }}
        userPrefs={userPrefs}
      />
      <ListItem button>
        <ListItemText
          onClick={() =>
            setOpenUserAlertPreferences(!openUserAlertsPreferences)
          }
          primary="User Alerts"
        />
      </ListItem>
      <Drawer
        disableEnforceFocus
        anchor="right"
        open={openUserAlertsPreferences}
        onClose={() => {
          setOpenApplyChangesModal(true);
        }}
        classes={{ paper: classes.paper }}
      >
        <Grid container>
          <Grid item xs={12} container>
            <Grid item xs={3}>
              <FormControlLabel
                value="top"
                control={
                  <StyledCheckbox
                    checked={userAlerts.isEmail}
                    onChange={({ target }) => {
                      const deepCopy = {
                        ...userAlerts,
                        isEmail: target.checked,
                      };
                      setUserAlerts(deepCopy);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 10 }}>Send Email</Typography>
                }
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                value="top"
                control={
                  <StyledCheckbox
                    checked={userAlerts.sendAlertsEmail}
                    onChange={({ target }) => {
                      const deepCopy = {
                        ...userAlerts,
                        sendAlertsEmail: target.checked,
                      };
                      setUserAlerts(deepCopy);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 10 }}>
                    Send Alerts Email
                  </Typography>
                }
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size={'small'}
                onChange={(ev) => setEmailAddressTxt(ev.target.value)}
                value={emailAddressTxt}
                style={{ width: '100%' }}
                InputProps={{ classes: { input: classes.input } }}
                onBlur={(ev) => {
                  userAlerts.emailAddress = ev.target.value;
                  let deepCopy = {};
                  Object.keys(userAlerts).forEach(
                    (key) => (deepCopy[key] = userAlerts[key])
                  );
                  setUserAlerts(deepCopy);
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} container>
            <Grid item xs={3}>
              <FormControlLabel
                value="top"
                control={
                  <StyledCheckbox
                    checked={userAlerts.isText}
                    onChange={({ target }) => {
                      const deepCopy = {
                        ...userAlerts,
                        isText: target.checked,
                      };
                      setUserAlerts(deepCopy);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 10 }}>Send Text</Typography>
                }
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                value="top"
                control={
                  <StyledCheckbox
                    checked={userAlerts.sendAlertsText}
                    onChange={({ target }) => {
                      const deepCopy = {
                        ...userAlerts,
                        sendAlertsText: target.checked,
                      };
                      setUserAlerts(deepCopy);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 10 }}>
                    Send Alerts Text
                  </Typography>
                }
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                size={'small'}
                onChange={(ev) => setPhoneNumberTxt(ev.target.value)}
                value={phoneNumberTxt}
                style={{ width: '90%' }}
                margin={'dense'}
                InputProps={{ classes: { input: classes.input } }}
                onBlur={(ev) => {
                  let phoneNumber = ev.target.value;
                  userAlerts.phoneNumber =
                    phoneNumber + '@' + convertToSmsGateWay(carrierTxt);
                  let deepCopy = {};
                  Object.keys(userAlerts).forEach(
                    (key) => (deepCopy[key] = userAlerts[key])
                  );
                  setUserAlerts(deepCopy);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                size={'small'}
                select
                value={convertFromSmsGateWay(carrierTxt)}
                style={{ width: '100%' }}
                margin={'none'}
                InputProps={{ classes: { input: classes.input } }}
                onChange={(ev) => {
                  let carrierTxt = ev.target.value;
                  setCarrierTxt(ev.target.value);
                  userAlerts.phoneNumber =
                    phoneNumberTxt + '@' + convertToSmsGateWay(carrierTxt);
                  let deepCopy = {};
                  Object.keys(userAlerts).forEach(
                    (key) => (deepCopy[key] = userAlerts[key])
                  );
                  setUserAlerts(deepCopy);
                }}
              >
                {phoneCarriers.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <Grid item xs={12} container>
            <Grid item xs={3}>
              <FormControlLabel
                value="top"
                control={
                  <StyledCheckbox
                    checked={userAlerts.isSoundAlert}
                    onChange={({ target }) => {
                      const deepCopy = {
                        ...userAlerts,
                        isSoundAlert: target.checked,
                      };
                      setUserAlerts(deepCopy);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 10 }}>
                    Send Sound Alert
                  </Typography>
                }
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                value="top"
                control={
                  <StyledCheckbox
                    checked={userAlerts.sendAlertsSound}
                    onChange={({ target }) => {
                      const deepCopy = {
                        ...userAlerts,
                        sendAlertsSound: target.checked,
                      };
                      setUserAlerts(deepCopy);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 10 }}>
                    Send Alerts Sound Alert
                  </Typography>
                }
                labelPlacement="end"
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={5}>
              <Button
                size={'small'}
                variant={'contained'}
                color={'primary'}
                onClick={testService}
              >
                Test Alert
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
    </div>
  );
}

const phoneCarriers = [
  'AT&T',
  'T-Mobile',
  'Verizon',
  'Sprint',
  'Virgin Mobile',
  'Boost Mobile',
  'Cricket Wireless',
  'Google Project Fi',
  'Republic Wireless',
  'Straight Talk',
  'Ting',
  'U.S. Cellular',
  //"none"
];

function convertToSmsGateWay(carrierTxt) {
  switch (carrierTxt) {
    case 'AT&T':
      return 'txt.att.net';
    case 'T-Mobile':
      return 'tmomail.net';
    case 'Verizon':
      return 'vtext.com';
    case 'Sprint':
      return 'messaging.sprintpcs.com';
    case 'Virgin Mobile':
      return 'vmobl.com';
    case 'Boost Mobile':
      return 'sms.myboostmobile.com';
    case 'Cricket Wireless':
      return 'mms.cricketwireless.net';
    case 'Google Project Fi':
      return 'msg.fi.google.com';
    case 'Republic Wireless':
      return 'text.republicwireless.com';
    case 'Straight Talk':
      return 'vtext.com';
    case 'Ting':
      return 'message.ting.com';
    case 'U.S. Cellular':
      return 'email.uscc.net';
    default:
      return carrierTxt.length > 0 ? carrierTxt : ''; //perhaps already in email form
  }
  return '';
}

function convertFromSmsGateWay(carrierTxt) {
  switch (carrierTxt) {
    case 'txt.att.net':
      return 'AT&T';
    case 'tmomail.net':
      return 'T-Mobile';
    case 'vtext.com':
      return 'Verizon';
    case 'messaging.sprintpcs.com':
      return 'Sprint';
    case 'vmobl.com':
      return 'Virgin Mobile';
    case 'sms.myboostmobile.com':
      return 'Boost Mobile';
    case 'mms.cricketwireless.net':
      return 'Cricket Wireless';
    case 'msg.fi.google.com':
      return 'Google Project Fi';
    case 'text.republicwireless.com':
      return 'Republic Wireless';
    case 'vtext.com':
      return 'Straight Talk';
    case 'message.ting.com':
      return 'Ting';
    case 'email.uscc.net':
      return 'U.S. Cellular';
    default:
      return carrierTxt;
  }
}

// const example = {
//   messageType: 'userPreferences',
//   json: {
//     exitTactics: {
//       PRESERVE_PROFIT: { amount: '50', activationProfitAmount: '100' },
//     },
//     quickTrade: {
//       instrument: '',
//       quantityBasis: '',
//       quantityBasisValue: 0,
//       accountNumber: '',
//       dataSource: 'LIVE',
//       brokerage: '',
//       optionDirection: '',
//       entryType: '',
//       limitOrder: {
//         offsetFromSetupPrice: 0,
//         limitPrice: 0,
//         quantityBasisValue: 0,
//         setLimitFromSetupBreakPrice: false,
//       },
//       candleBreak: {
//         candleDuration: 1,
//         quantityBasisValue: 0,
//         waitUntilCurrentCandleCloses: false,
//         breakBy: 0,
//       },
//       break: { priceToBreak: 0 },
//       nearestOtmItm: 'nearestOtm',
//       maxOptionPrice: 0,
//       expirationWeeksAway: 0,
//       notExpiringToday: false,
//       workOrders: false,
//       getAwayOffsetPct: 0.1,
//       pctBetweenBidAsk: 0.5,
//       pctIncreasePerOrderAttempt: 0.1,
//     },
//     tradePlanConfig: {
//       status: 'ARMED',
//       dataSource: 'LIVE',
//       brokerage: 'BACKTEST',
//       accountNumber: 'BACKTEST',
//       goLong: false,
//       goShort: false,
//       workOrders: false,
//       workOrdersOnEntry: true,
//       workOrdersOnExit: true,
//       quantityBasis: 'DOLLARS',
//       strategy: 'BASIC_TRADING_SYSTEM',
//       instrument: 'stock',
//       symbol: '',
//       startPeriod: 'open',
//       setup: 'none',
//       terminateWhenFlat: true,
//       restartSystemOncePositionHasFlattened: false,
//       flattenAtMarketClose: false,
//       getAwayOffsetPct: 0.1,
//       pctBetweenBidAsk: 0.5,
//       pctIncreasePerOrderAttempt: 0.1,
//       startHour: 9,
//       startMin: 30,
//       evaluateQuotes: false,
//       persistTradePlanOnFailedFiltersOrValidation: false,
//       useDifferentWorkOrderFieldsOnExit: false,
//       getAwayOffsetPctOnExit: 0.1,
//       pctBetweenBidAskOnExit: 0.5,
//       pctIncreasePerOrderAttemptOnExit: 0.1,
//       useDifferentWorkOrderFieldsOnTarget: false,
//       getAwayOffsetPctOnTarget: 0.1,
//       pctBetweenBidAskOnTarget: 0.5,
//       pctIncreasePerOrderAttemptOnTarget: 0.1,
//     },
//     optionManagement: {
//       optionChoices: {},
//       expirationDates: [],
//       buyOrSellOption: 'LONG',
//       OTM: false,
//       ITM: false,
//       notExpiringToday: false,
//       optionChainStrategy: { hugCurrentPrice: { numOfStrikes: 5 } },
//       optionFilters: { tightSpreadPct: { maxOptionSpreadPct: 0.05 } },
//     },
//     tradePlanDefaultEntryTactics: {
//       marketOrder: { enabled: true },
//       limitOrder: {
//         enabled: false,
//         offset: 0,
//         setLimitFromSetupBreakPrice: false,
//       },
//       candleBreak: {
//         enabled: false,
//         candleDuration: 0,
//         waitUntilCurrentCandleCloses: false,
//         breakBy: 0,
//       },
//       qtyBasisValues: {
//         dollarStock: 1000,
//         dollarOption: 0,
//         qtyStock: 0,
//         qtyOption: 0,
//       },
//     },
//     optionRadioButtons: 'none',
//     defaultSavedTpConfigKey: 0,
//     restartSettings: {
//       maxRestartAttempts: 0,
//       isMaxRestartAttempts: false,
//       maxLoss: 0,
//       isMaxLoss: false,
//       maxMinutesInTradePlan: 0,
//       isMaxMinutesInTradePlan: false,
//       numberOfTrades: 0,
//       isNumberOfTrades: false,
//       deactivateOnRestart: false,
//     },
//     userAlerts: { isEmail: false, isText: false, isSoundAlert: false },
//   },
// };
